import { useEffect, useState } from 'react'

const useCountryDetection = () => {
  const [detectedCountryCode, setDetectedCountryCode] = useState<string>('')

  useEffect(() => {
    const detectCountry = async () => {
      try {
        // First try to get country from navigator.language
        const browserLocale =
          navigator.language || (navigator as any).userLanguage
        if (browserLocale) {
          const countryCode = browserLocale.split('-')[1]?.toUpperCase()
          if (countryCode) {
            setDetectedCountryCode(countryCode)
            return
          }
        }

        // If browser locale doesn't provide country, try geolocation API
        try {
          const response = await fetch('https://ipapi.co/json/')
          const data = await response.json()
          if (data.country_code) {
            setDetectedCountryCode(data.country_code)
          }
        } catch (error) {
          console.error('Error detecting country:', error)
          // Default to US if detection fails
          setDetectedCountryCode('US')
        }
      } catch (error) {
        console.error('Error in country detection:', error)
        // Default to US if all detection methods fail
        setDetectedCountryCode('US')
      }
    }

    detectCountry()
  }, [])

  return detectedCountryCode
}

export default useCountryDetection
